import { nanoid } from "nanoid"
import { InputText } from "primereact/inputtext"
import { useState } from "react"

import CustomButtom from "common/components/Button/Button"

const CamposPersonalizadosForm = ({
  handleBlur,
  values,
  handleOpenModal,
  handleElement,
}: $TSMigrationFixMe) => {
  const [campoPersonalizado, setCampoPersonalizado] = useState({
    clave: values?.originalObject?.clave,
    valor: values?.originalObject?.valor,
  })

  const handleChangeCampoPersonalizado = (
    value: $TSMigrationFixMe,
    key: $TSMigrationFixMe
  ) => {
    setCampoPersonalizado({ ...campoPersonalizado, [key]: value })
  }

  const handleAddCampoPersonalizado = () => {
    if (campoPersonalizado.clave && campoPersonalizado.valor) {
      handleElement({
        label: campoPersonalizado?.clave,
        value: campoPersonalizado?.valor,
        originalObject: campoPersonalizado,
        key: values?.key || nanoid(),
        elementId: values?.elementId || nanoid(),
      })
    }
  }

  return (
    <>
      <div className='p-fluid mb-3'>
        <div className='input_box  mb-3'>
          <label htmlFor='clave'>Campo</label>
          <InputText
            id='clave'
            name='clave'
            onBlur={handleBlur}
            // @ts-expect-error TS(2769): No overload matches this call.
            minFractionDigits={2}
            values={campoPersonalizado?.clave}
            defaultValue={campoPersonalizado?.clave}
            handleSetComision
            onChange={(e) =>
              handleChangeCampoPersonalizado(e.target.value, "clave")
            }
          />
        </div>
        <div className='input_box'>
          <label htmlFor='valor'>Valor</label>
          <InputText
            id='valor'
            name='valor'
            onBlur={handleBlur}
            // @ts-expect-error TS(2769): No overload matches this call.
            values={campoPersonalizado?.valor}
            onChange={(e) =>
              handleChangeCampoPersonalizado(e.target.value, "valor")
            }
            defaultValue={campoPersonalizado?.valor}
          />
        </div>
      </div>
      <div>
        <div className='departaments-modal__actions'>
          <p onClick={() => handleOpenModal(null, false)}>Cancelar</p>
          <CustomButtom
            onClick={handleAddCampoPersonalizado}
            className='tw-ml-2 !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
          >
            {values?.elementId ? `Editar` : `Crear`}
          </CustomButtom>
        </div>
      </div>
    </>
  )
}

export default CamposPersonalizadosForm
